import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
export default new Vuex.Store({
  state: {
    app_type: 'Main',
    account: {},
    pos:{
      enterprise_name: '',
      license_type: '',
      license: '',
      currency_on: 0
    },
    currency:[
      {
        "id": "",
        "currency_code": "Bs",
        "currency_name": "Bolívar",
        "dec_code": ".",
        "kil_code": ",",
        "exchange_round": 2,
        "exchange": "1.000000"
      },
      {
        "id": "",
        "currency_code": "$",
        "currency_name": "Dolar",
        "dec_code": ".",
        "kil_code": ",",
        "exchange_round": 2,
        "exchange": "36.310000"
      }
    ],
    app_args: {
      report_type: 'top',
      report_date: 1,
      extension_id: 0,
      extension_name: '',
    },
    page_args: {
      cate_id: 0,
      cate_name: '',
    },
    page_cate_args: {
      cate_id: 0,
      cate_name: '',
    },
    page_ext_args: {
      ext_id: 0,
      ext_name: '',
    },
    page_cashier_args: {
      cashier_id: 0,
      cashier_name: '',
    },
    page_salesman_args: {
      salesman_id: 0,
      salesman_name: ''
    },
    body_h:0,
    set:{
      app_ver: 2024091201
    },
    client_keyword: '',
    client_id: '',
    ext_id: '',
    account_id: '',
    auth:{},
    sound: false,
    win_box_app: '',
    sec_box_app: '',
    sales_list: 1,
    pay:'',
    pay_box: '',
    search_list:[],
    loading: false,
    alert: {
      type: '',
      msg: ''
    },
    confim_box:{
      type: '',
      msg: '',
      focus:'',
      check: false,
      arg1: '',
      arg2: ''
    },
    auth_check:{
      type: '',
      msg: '',
      focus:'',
      select: 1,
      check: false,
      arg1: '',
      arg2: '',
      auth_user: 0
    },
    modal_box:{
      type: ''
    },
    pay_modal:{
      type: ''
    },
    price_check:false,
    admin_page_name: '',
  },
  mutations: {
    //设置APP类型
    setApp (state, arr) {
      state.app_type = arr;
      localStorage.setItem('app_type', arr);
    },
    //设置使用者
    setAccount (state, arr) {
      state.account = arr
      //localStorage.setItem('user', JSON.stringify(arr));
    },
    //设置系统配置
    setPos (state, arr) {
      //获取本地存储的配置
      let pos = localStorage.getItem('pos');
      //如果存在则合并
      if(pos){
        state.pos = Object.assign({},JSON.parse(pos),arr);
      }else{
        //否则合并到当前配置
        state.pos = Object.assign({},state.pos,arr);
      }
      //再存入本地
      localStorage.setItem('pos', JSON.stringify(state.pos));
    },
    //设置货币
    setCurrency (state, arr) {
      state.currency = arr
    },
    //设置APP参数
    setAppArgs (state, arr) {
      //判断arr对象是否为空,如果为空恢复默认参数
      if(JSON.stringify(arr) == "{}"){
        arr = {
          report_type: 'top',
          report_date: 1,
          extension_id: 0,
          extension_name: '',
          product_status: 1,
          product_page: 1,
          product_keyword: '',
          cate_id: '',
          cate_name: '',
        }
      }
      //先获取储存在本地的参数
      let app_args = localStorage.getItem('app_args');
      //如果存在则合并
      if(app_args){
        state.app_args = Object.assign({},JSON.parse(app_args),arr);
      }else{
        //否则合并到当前参数
        state.app_args = Object.assign({},state.app_args,arr);
      }
      //再存入本地
      localStorage.setItem('app_args', JSON.stringify(state.app_args));
    },
    //设置页面参数
    setPageArgs (state, arr) {
      let page_args = this.state.page_args;
      state.page_args = Object.assign({},arr,page_args);
      //console.log(this.state.page_args);
    },
    //设置页面分类参数
    setPageCateArgs (state, arr) {
      state.page_cate_args = arr
    },
    //设置页面分机参数
    setPageExtArgs (state, arr) {
      state.page_ext_args = arr
    },
    //设置页面收银员参数
    setPageCashierArgs (state, arr) {
      state.page_cashier_args = arr
    },
    //设置页面销售员参数
    setPageSalesmanArgs (state, arr) {
      state.page_salesman_args = arr
    },
    //设置页面名称
    setAdminPageName (state, arr) {
      state.admin_page_name = arr
    },
    //设置加载状态
    setLoading (state, arr) {
      state.loading = arr
    },
    //设置本机设置
    setSet (state, arr) {
      state.set = arr
    },
    //设置当前货币
    setCurrency (state, arr) {
      state.currency = arr
    },
    //设置弹出警告
    setAlert (state, arr) {
      state.alert = arr
    },
    //设置搜索结果
    setSearchList (state, arr) {
      state.search_list = []
      state.search_list = arr
    },
    //设置客户搜索关键词
    setClientKeyword(state, arr){
      state.client_keyword = arr;
      localStorage.setItem('client_keyword', arr);
    },
    //设置客户ID
    setClientId(state, arr){
      state.client_id = arr;
      localStorage.setItem('client_id', arr);
    },
    //设置分机ID
    setExtId(state, arr){
      state.ext_id = arr;
      localStorage.setItem('ext_id', arr);
    },
    setAccountId(state, arr){
      state.account_id = arr;
      localStorage.setItem('account_id', arr);
    },
    //设置主弹出窗口
    setWinApp (state, arr) {
      state.win_box_app = arr
    },
    //设置副弹出窗口
    setSecApp(state,arr){
      state.sec_box_app = arr
    },
    //设置确认框
    setConfimBox(state,arr){    
      state.confim_box = arr
      if(arr['type']){
        state.confim_box.check = false
      }else{
        if(arr['focus']){
          setTimeout(() => {
            arr['_this'].$refs[arr['focus']].focus();
          }, 50);
        }
      }
      if(state.confim_box.check){
        arr['_this'][arr['method']](arr['arg1'],arr['arg2'])
        state.confim_box.check = false
      }
    },
    //设置密码验证框
    setAuthCheck(state,arr){
      state.auth_check = arr
      if(arr['type']){
        state.auth_check.check = false
      }else{
        if(arr['focus']){
          setTimeout(() => {
            if(arr['select'] == 1){
              arr['_this'].$refs[arr['focus']].select();
            }else{
              arr['_this'].$refs[arr['focus']].focus();
            }
          }, 50);
        }
      }
      if(state.auth_check.check){
        //console.log(arr)
        arr['_this'][arr['method']](arr['arg1'],arr['arg2']);
        setTimeout(() => {
          state.auth_check.check = false
        },100);
      }
    },
    //设置弹出小窗口
    setModalBox(state,arr){
      state.modal_box = arr
    },
    //设置付款状态
    setSalesList(state,arr){
      state.sales_list = arr
    },
    //设置付款状态
    setPay(state,arr){
      state.pay = arr
    },
    //设置付款窗口
    setPayBox(state,arr){
      state.pay_box = arr
    },
    //设置付款弹窗
    setPayModal(state,arr){
      state.pay_modal = arr
    },
    //设置权限
    setAuth(state,arr){
      state.auth = arr
    },
    //设置声音
    setSound(state,arr){
      state.sound = arr
    },
    //设置价格查询信息
    setPriceCheck(state,arr){
      state.price_check = arr
    },
    //设置APP高度
    setBodyH(state,_this){
      if (_this.$refs.hasOwnProperty('app_head')) {
        var tb_h = _this.$refs.app_head.offsetHeight + _this.$refs.app_foot.offsetHeight;
        var body_h = window.innerHeight - tb_h;
        state.body_h = body_h;
        console.log(body_h);
      } 
    },
  },
  getters:{
    getUser(state){
      if(!state.user){
        state.user = localStorage.getItem('user')
      }
      return state.user
    }
  },
  actions: {
  },
  modules: {
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js